import { createBrowserHistory } from 'history';
import { dialogModalHandler } from 'src/utils/helpers';
import { IUser } from 'src/utils/interfaces/user';
import {
    LABEL_TEXT_MENU_PROFILE_LOGOUT,
    // Temporarily hiding the profile settings menu – enable when feature is ready
    // LABEL_TEXT_MENU_PROFILE_SETTINGS,
} from '../../../../../localization/resouceKeys';
import { NavLink } from 'react-router-dom';
import React from 'react';
import { USER_ACTIONS } from '../../../../../utils/enums/user-store-actions.enum';
import userStore from '../../../../../store/userStore';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const history = createBrowserHistory();

export const profileLinks = [
    // Temporarily hiding the profile settings menu – enable when feature is ready
    // { name: LABEL_TEXT_MENU_PROFILE_SETTINGS, path: '/' },
    {
        name: LABEL_TEXT_MENU_PROFILE_LOGOUT,
        handler: () => {
            sessionStorage.clear();
            userStore.dispatch({
                type: USER_ACTIONS.LOGOUT,
                payload: undefined,
            });
            history.push('/login');
            location.reload();
        },
    },
];

const ProfileItems = ({
    person,
}: {
    person: { name: string; email: string };
}) => {
    const { t } = useTranslation();
    const dialogModal = useSelector((state: IUser) => {
        return state.dialogModal;
    });
    const dispatch = useDispatch();
    return (
        <>
            <li className={'menu-items name'}>
                <a href={'#'}>
                    {person.name}
                    <span>{person.email}</span>
                </a>
            </li>
            {profileLinks.map((e: any, i) => {
                return (
                    <li className={'menu-items'} key={i}>
                        {e.path ? (
                            <NavLink
                                to={e.path}
                                className={'#'}
                                onClick={(event) =>
                                    dialogModalHandler(
                                        event,
                                        dispatch,
                                        dialogModal,
                                    )
                                }
                            >
                                {t(e.name)}
                            </NavLink>
                        ) : (
                            <a
                                className={'#'}
                                onClick={(event) => {
                                    if (dialogModal.isModalActive) {
                                        dialogModalHandler(
                                            event,
                                            dispatch,
                                            dialogModal,
                                        );
                                    } else if (e.handler) {
                                        e.handler();
                                    }
                                }}
                            >
                                {t(e.name)}
                            </a>
                        )}
                    </li>
                );
            })}
        </>
    );
};

export default ProfileItems;
